<template>
  <header class="app-header">
    <div class="node-header">
      <router-link to="/debate" class="logo-link" style="cursor: pointer;">
        <img :src="getAssetUrl('logo.png')" alt="Logo" class="logo-image" />
      </router-link>

      <nav class="nav-menu">
        <router-link to="/" class="nav-link" :class="{ active: $route.path === '/' }">
          首頁
        </router-link>
        <router-link to="/debate" class="nav-link" :class="{ active: $route.path.startsWith('/debate') }">
          辯論大廳
        </router-link>
        <button class="login-pill" type="button" @click="goLogin">
          登入
        </button>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { authApi } from '@/utils/api/auth.js'
import { getAssetUrl } from '@/utils/getAssetUrl.js'

const route = useRoute()

function goLogin() {
  const redirectTarget = typeof route.query?.redirect === 'string' ? route.query.redirect : '/'
  const callbackUrl = new URL('/auth/callback', window.location.origin)
  callbackUrl.searchParams.set('redirect', redirectTarget)
  window.location.assign(authApi.getLineLoginUrl(callbackUrl.toString()))
}
</script>

<style scoped>
.app-header {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #111;
}

.node-header {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 32px;
}

.logo-link {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.logo-image {
  width: 40px;
  height: 35px;
  display: block;
  object-fit: contain;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-left: auto;
  flex: 0 0 auto;
  width: auto;
  justify-content: flex-end;
}

.nav-link {
  font-size: 16px;
  color: #111;
  text-decoration: none;
  line-height: 1;
  padding: 8px 16px;
  border-radius: 4px;
}

.nav-link.active {
  font-weight: 700;
}

.login-pill {
  min-width: 142px;
  height: 26px;
  border: 1px solid #9f9f9f;
  border-radius: 6px;
  background: #d9d9d9;
  color: #111;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  padding: 0 18px;
  box-shadow: none;
  appearance: none;
  -webkit-appearance: none;
}

.login-pill:hover {
  background: #d2d2d2;
  transform: none;
  box-shadow: none;
}

@media (max-width: 768px) {
  .node-header {
    gap: 16px;
    padding: 24px;
  }

  .nav-menu {
    gap: 16px;
    flex: 0 0 auto;
  }

  .nav-link {
    font-size: 15px;
    padding: 6px 12px;
  }

  .login-pill {
    min-width: 100px;
    padding: 0 14px;
  }
}
</style>
